import { render, staticRenderFns } from "./ElectionsButtons.vue?vue&type=template&id=3175e79f"
import script from "./ElectionsButtons.vue?vue&type=script&lang=js"
export * from "./ElectionsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports